const normalizePositiveInteger = (value, fallback = null) => {
  const normalized = Math.trunc(Number(value))
  return Number.isFinite(normalized) && normalized > 0 ? normalized : fallback
}

const normalizeText = (value) => {
  if (value === undefined || value === null) return ''
  return String(value).trim()
}

const resolveRowPromotionCode = (row) =>
  row?.promotionCode ??
  row?.promotion_code ??
  row?.activityCode ??
  row?.activity_code ??
  row?.comboVO?.promotionCode ??
  row?.comboVO?.activityCode

export const resolveCartComboGroupPromotionCode = (group) => {
  const first = group?.rows?.[0] || {}
  return normalizeText(
    group?.promotionCode ??
      group?.activityCode ??
      resolveRowPromotionCode(first)
  )
}

const resolveGroupPromotionType = (group) => {
  const first = group?.rows?.[0] || {}
  const normalized = Number(group?.promotionType ?? first?.promotionType)
  return normalized === 4 || normalized === 5 ? normalized : 0
}

const resolveComboItemType = (row) => {
  const normalized = normalizePositiveInteger(row?.comboItemType)
  return normalized === 1 || normalized === 2 ? normalized : null
}

const resolveBasketId = (row) => row?.basketId ?? row?.id

const buildComboItems = (rows, getQuantity, promotionType) => {
  const seen = new Set()
  const items = []
  for (const row of Array.isArray(rows) ? rows : []) {
    const skuId = normalizeText(row?.skuId)
    if (!skuId || seen.has(skuId)) continue
    seen.add(skuId)
    const item = {
      skuId,
      prodCount: normalizePositiveInteger(getQuantity?.(row), 1),
    }
    const comboItemType = resolveComboItemType(row)
    if (promotionType === 4 && comboItemType) item.comboItemType = comboItemType
    items.push(item)
  }
  return items
}

/**
 * Build the mutation plan for saving an edited combo group.
 *
 * The group leader basketId identifies the old instance and comboItems carries the complete
 * replacement. changeItem/v3 replaces the group atomically and regenerates comboKey server-side.
 *
 * @param {Object} input
 * @param {Object} input.group
 * @param {Array<Object>} input.selectedRows
 * @param {(row: Object) => number} input.getQuantity
 * @returns {{ mode: 'replace', changeItems: Object }}
 */
export const buildCartComboGroupMutation = ({ group, selectedRows, getQuantity }) => {
  const currentRows = Array.isArray(group?.rows) ? group.rows : []
  const promotionType = resolveGroupPromotionType(group)
  const promotionCode = resolveCartComboGroupPromotionCode(group)
  const comboItems = buildComboItems(selectedRows, getQuantity, promotionType)

  if (!promotionType) throw new Error('购物车组缺少有效的套餐/组合活动类型')
  if (!promotionCode) throw new Error('购物车组缺少 promotionCode')
  if (!comboItems.length) throw new Error('请至少选择一个活动商品')

  const existingRows = currentRows.filter(
    (row) => normalizeText(resolveBasketId(row)) && normalizeText(row?.skuId)
  )
  const leaderBasketId =
    group?.selectBasketId ??
    currentRows[0]?.comboGroupLeaderBasketId ??
    resolveBasketId(existingRows[0])
  if (!normalizeText(leaderBasketId)) throw new Error('购物车组缺少 leader basketId')

  const changeItems = {
    basketId: leaderBasketId,
    promotionType,
    promotionCode,
    comboItems,
    isChecked: currentRows.some((row) => row?.checked !== false) ? 1 : 0,
  }
  return {
    mode: 'replace',
    changeItems,
  }
}
